module.exports = __webpack_public_path__ + "static/media/sidebar-5.08efb632.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sidebar-5.jpg
// module id = 455
// module chunks = 1